<template>
  <ConnectionApp />
</template>

<script>
// import LoginedPageMixins from '@/mixins/LoginedPageMixins'

import ConnectionApp from '@/components/Pages/Connections/ConnectionApp/ConnectionApp.vue'

export default {
  // mixins : [
  //   LoginedPageMixins
  // ],

  components : {
    ConnectionApp
  },
  
  // async mounted(){
  //   await this.initializePage({
  //     title : 'メルティングポッド'
  //   });
  // }
}
</script>

<style lang="scss">

</style>